import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import { EmptyBox } from "components/StyledComponents";
import { getBlockchainName, getBlockchainNetwork } from "utils";
import { resetAllPaymentReqs, listAllPaymentReqs } from "store/actions";

import ExpandableListView from "components/ExpandableListView/ExpandableListView";
import { history } from "utils";

function Requested() {
    const dispatch = useDispatch();

    const { data, showViewMore } = useSelector(({ paymentReqs: { list, showViewMore } }) => ({
        data: list,
        showViewMore: showViewMore,
    }));

    useEffect(() => {
        dispatch(resetAllPaymentReqs());
        fetchUserTxns();
    }, []);

    const fetchUserTxns = () => {
        dispatch(listAllPaymentReqs({ type: "requested" }));
    };

    const colorIndicator = (element, arr = [], style = {}) => {
        arr.map((e) => {
            if (element[e.field] === e.value) {
                style = { color: e.color };
            }
            return null;
        });
        return style;
    };

    return (
        <>
            {data ? (
                <ExpandableListView
                    pairs={[
                        { key: "REQUEST ID", value: "req_id" },
                        {
                            key: "Status",
                            render: (e) => (
                                <div
                                    style={colorIndicator(e, [
                                        { field: "status", value: "paid", color: "#6bc654" },
                                        { field: "status", value: "rejected", color: "red" },
                                        { field: "status", value: "pending", color: "#a1a1a1" },
                                    ])}
                                >
                                    {e.status}
                                </div>
                            ),
                        },
                        {
                            key: "Amount",
                            render: (rowData) => `${rowData?.amount} ${rowData?.currency.toUpperCase()}`,
                        },
                        // { key: "Network", render: (rowData) => getBlockchainName(rowData?.chain_network) },
                        { key: "Network", render: () => "solana" },
                        { key: "Type", value: "type" },
                        {
                            key: "Created At",
                            render: (rowData) => moment.unix(rowData?.created_at).format("DD-MM-YYYY hh:mm A"),
                        },
                        { key: "Requested to email", render: (rowData) => (rowData?.to_uid ? rowData.to_uid?.email : "-") },
                        // { key: "Requested to user", render: (rowData) => (rowData?.to_uid ? rowData.to_uid?.name : "-") },
                    ]}
                    leftTitle={[
                        {
                            key: "chain_network",
                            render: (e) => `${getBlockchainName(e?.chain_network)}`,
                        },
                        {
                            key: "created_at",
                            render: (e) => <>{moment.unix(e?.created_at).format("DD-MM-YYYY hh:mm A")}</>,
                        },
                    ]}
                    rightTitle={{
                        main: {
                            render: (e) => (
                                <b
                                    style={colorIndicator(e, [
                                        { field: "type", value: "received", color: "#6bc654" },
                                        { field: "type", value: "transferred", color: "red" },
                                    ])}
                                >
                                    {e?.amount} {e?.currency.toUpperCase()}
                                </b>
                            ),
                        },
                        sub: {
                            render: (e) => (
                                <div
                                    style={colorIndicator(e, [
                                        { field: "status", value: "paid", color: "#6bc654" },
                                        { field: "status", value: "rejected", color: "red" },
                                        { field: "status", value: "pending", color: "#a1a1a1" },
                                    ])}
                                >
                                    {e.status}
                                </div>
                            ),
                        },
                    }}
                    data={data}
                    iconImg={{ render: (e) => `${getBlockchainNetwork(e.chain_network)}` }}
                    showViewMoreButton={showViewMore}
                    viewMoreButtonClick={fetchUserTxns}
                    endButton={{ title: "open request", action: (e) => history.push(`/app/request/${e?.req_id}`) }}
                />
            ) : (
                <EmptyBox>No data found</EmptyBox>
            )}
        </>
    );
}

export default Requested;
